import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

export const MAX_DURATION_SEC = 30;

const FixedWidthNum: React.FC<{ num: number }> = ({ num }) => {
	return (
		<Text
			variant="body"
			size="medium"
			className="text-typography-weak inline-block min-w-[2ch] text-right tabular-nums"
		>
			{num.toFixed(0)}
		</Text>
	);
};

export const RecorderTimeLimit: React.FC<{ duration?: number }> = ({ duration }) => {
	return (
		<div className="flex justify-center" data-testid="recorder-time-limit">
			<Text variant="body" size="medium" className="text-typography-weak tabular-nums">
				{duration === undefined ? (
					<TranslateHtml
						value="corgi.petition_actions.supporter_voice_video.record.recording_limit"
						replacements={{
							maxDuration: <FixedWidthNum num={MAX_DURATION_SEC} />,
						}}
					/>
				) : (
					<TranslateHtml
						value="corgi.petition_actions.supporter_voice_video.record.recording_progress"
						replacements={{
							currentDuration: <FixedWidthNum num={duration} />,
							maxDuration: <FixedWidthNum num={MAX_DURATION_SEC} />,
						}}
					/>
				)}
			</Text>
		</div>
	);
};
